import { Cubby } from "../Cubby";

export const mustRetainInWalletToPayForChannelClosures = (cubby: Cubby) => {
  let amount = 0;
  if (cubby.hasUnclosedChannels) {
    amount =
      cubby.numberOfUnclosedChannelsOpenedByUser *
      cubby.safeEstimatedClosureCost;
  }
  return amount;
};

export const amountThatCouldBeUsedToOpenChannels = (cubby: Cubby) => {
  // we really need to be sure user has enough left over
  // to close a channel during high fees
  console.log("safe chain balance", cubby.safeChainBalance);
  console.log(
    "must retain in wallet to pay for channel closures",
    cubby.mustRetainInWalletToPayForChannelClosures
  );
  console.log("safe estimated closure cost", cubby.safeEstimatedClosureCost);
  const safeEstimatedClosureCostTimesFour = Math.min(
    cubby.safeEstimatedClosureCost * 8,
    25_000
  );
  return Math.max(
    cubby.safeChainBalance -
      (cubby.mustRetainInWalletToPayForChannelClosures +
        safeEstimatedClosureCostTimesFour),
    0
  );
};
